import React from "react";
import SnapsWiseAudio from "./SnapsWiseAudio";
import PracticeControlsPanel from "./PracticeControlsPanel";
import AIAssessmentPanel from "./AIAssessmentPanel";
import PresentationNarratorPanel from "./PresentationNarratorPanel";
import PresentationUserIntonationPanel from "./PresentationUserIntonationPanel";
import PresentationSentencePanel from "./PresentationSentencePanel";

const PresentationModeView = ({
  audioref,
  fullaudio,
  timeUpdate,

  segment,
  segments,
  handlePreviousSegment,
  handleNextSegment,

  isgranted,
  getMicrophonePermission,
  practiceMode,
  recordingStatus,
  isPlayingSegment,
  recordingProgress,
  handlePlayPause,
  handleMainAction,
  getButtonConfig,
  rate,
  setRate,

  loading,
  assessment,

  subject,
  file,
  handleLaneWordClick,
  broadcastTime,
  visualizationView,
  auth,
  resolvedAssessmentAudioUrl,
  resolvedNarratorAssessmentAudioUrl,
  canUsePronunciationApi,
  echoingPhase,
  isCueActive,
}) => {
  return (
    <div className="flex-1 min-w-0 min-h-0 flex flex-col overflow-hidden bg-gradient-to-br from-slate-50 via-blue-50/20 to-indigo-100/20">
      <div className="flex-1 min-h-0 min-w-0 overflow-y-auto overflow-x-hidden px-2 py-2 xl:px-3 xl:py-2 pb-3">
        <SnapsWiseAudio
          audioref={audioref}
          fullaudio={fullaudio}
          timeUpdate={timeUpdate}
        />

        <div className="max-w-[1420px] mx-auto flex flex-col">
          <PresentationNarratorPanel
            segment={segment}
            subject={subject}
            file={file}
            handleLaneWordClick={handleLaneWordClick}
            broadcastTime={broadcastTime}
            audioref={audioref}
            visualizationView={visualizationView}
            rate={rate}
            setRate={setRate}
          />

          <div className="[&>div]:bg-white/80 [&>div]:border-white/40 [&>div]:shadow-lg [&>div]:shadow-blue-500/5">
           <PracticeControlsPanel
  isgranted={isgranted}
  getMicrophonePermission={getMicrophonePermission}
  practiceMode={practiceMode}
  recordingStatus={recordingStatus}
  recordingPhase={
    loading
      ? "processing"
      : recordingStatus === "recording"
      ? "recording"
      : "idle"
  }
  echoingPhase={echoingPhase}
  shadowCountdownActive={isCueActive && recordingStatus !== "recording"}
  isPlayingSegment={isPlayingSegment}
  recordingProgress={recordingProgress}
  handlePlayPause={handlePlayPause}
  handleMainAction={handleMainAction}
  getButtonConfig={getButtonConfig}
  rate={rate}
  setRate={setRate}
  audioref={audioref}
  showSpeedControls={false}
  compact={true}
/>
          </div>

          <PresentationUserIntonationPanel
            assessment={assessment}
            segment={segment}
            visualizationView={visualizationView}
            auth={auth}
            resolvedAssessmentAudioUrl={resolvedAssessmentAudioUrl}
            resolvedNarratorAssessmentAudioUrl={resolvedNarratorAssessmentAudioUrl}
          />

          <PresentationSentencePanel
            segment={segment}
            segments={segments}
            handlePreviousSegment={handlePreviousSegment}
            handleNextSegment={handleNextSegment}
          />

          {canUsePronunciationApi && (
  <div className="[&>div]:bg-white/80 [&>div]:border-white/40 [&>div]:shadow-lg [&>div]:shadow-purple-500/5">
    <AIAssessmentPanel
      assessment={assessment}
      canUsePronunciationApi={canUsePronunciationApi}
      segment={segment}
    />
  </div>
)}
        </div>
      </div>
    </div>
  );
};

export default PresentationModeView;